$('.js-list1').slick({
  infinite: true,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: 'linear',
  arrows: false,
  dots: false,
  variableWidth: true,
  pauseOnHover:false,
  draggable: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(document).ready(function () {
  $('#select1,#select2,#select3,#select4,#select5').css('color', '#C4C4C4');
  $('#select1').change(function () {
    var current = $('#select1').val();
    if (current != 'null') {
      $('#select1').css('color', '#444D4C');
    } else {
      $('#select1').css('color', '#C4C4C4');
    }
  });
  $('#select2').change(function () {
    var current = $('#select2').val();
    if (current != 'null') {
      $('#select2').css('color', '#444D4C');
    } else {
      $('#select2').css('color', '#C4C4C4');
    }
  });
  $('#select3').change(function () {
    var current = $('#select3').val();
    if (current != 'null') {
      $('#select3').css('color', '#444D4C');
    } else {
      $('#select3').css('color', '#C4C4C4');
    }
  });
  $('#select4').change(function () {
    var current = $('#select4').val();
    if (current != 'null') {
      $('#select4').css('color', '#444D4C');
    } else {
      $('#select4').css('color', '#C4C4C4');
    }
  });
  $('#select5').change(function () {
    var current = $('#select5').val();
    if (current != 'null') {
      $('#select5').css('color', '#444D4C');
    } else {
      $('#select5').css('color', '#C4C4C4');
    }
  });
});

// QA
$('.js-accor').on('click', function () {
  $(this).next('.js-accon-cont').slideToggle();
  $(this).children('.js-accon-icon').toggleClass('is-active');
});

// $('.l-aside').scrollToFixed({
//   limit: 500,
//   dontSetWidth: true,
//   marginTop: 150,
//   zIndex: 1,
//   // limit: $('.l-content').outerHeight() + 400 - $('.l-aside').outerHeight()
// });

// /* ======================================
// Scroll animation
// ====================================== */
// $('a[href*=\\#]:not([href=\\#])').on('click', function () {
//   if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
//     && location.hostname == this.hostname) {
//     let $target = $(this.hash);
//     $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
//     let offsetTop = 0;
//     // ANCHOR WHEN HEADER FIXED
//     // offsetTop = $("#g-header").innerHeight();

//     if ($target.length) {
//       let targetOffset = $target.offset().top - offsetTop;
//       $('html,body').animate({ scrollTop: targetOffset }, 600);
//       return false;
//     }
//   }
// });

// Assign active class to nav links while scolling
$(window)
  .scroll(function () {
    var scrollDistance = $(window).scrollTop();
    $('.item-section').each(function (i) {
      if ($(this).position().top <= scrollDistance) {
        $('.c-side1 a.c-side1__link.is-current').removeClass('is-current');
        $('.c-side1 a.c-side1__link').eq(i).addClass('is-current');
      }
    });

    if ($('.c-side1__sub').find('.is-current').length) {
      $('.is-parent').addClass('is-current');
    } else $('.is-parent').removeClass('is-current');
  })
  .scroll();

$(document).ready(function () {
  $('.c-list4__box').matchHeight();
});

// var distance = $('.c-parallax-image').offset().top - 60,
//     $window = $(window);
// $window.scroll(function() {
//     if ( $window.scrollTop() >= distance ) {
//       $('.c-parallax-image').addClass('is-top');
//     }
//     else
//       $('.c-parallax-image').removeClass('is-top');
// });

var target = window.location.hash,
target = target.replace('#', '');
window.location.hash = "";
$(window).on('load', function () {
	if (target) {
    $('html, body').animate({
      scrollTop: $("#" + target).offset().top - $(".c-head").outerHeight()
    }, 1000, 'swing', function () { });
  }
});